import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-49" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-50" data-mp="c6ivdvtic587">
        <h2 className="text-[1.15rem] font-black uppercase leading-tight text-white sm:text-[1.7rem]" data-id="element-51" data-mp="c7k8e5u331sk">
          ONE LAST QUESTION
        </h2>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-52" data-mp="m4ym3xomhch6">
          When an oven won't heat, a fryer won't ignite, refrigeration equipment won't cool, or a
          dishwasher stops working...
        </p>
        <p className="mt-1 font-heading text-[0.9rem] font-extrabold leading-tight text-gold sm:text-[1.1rem]" data-id="element-53" data-mp="vtq87p7052k6">
          Do you immediately know what you should check next?
        </p>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-54" data-mp="14uwpi0hh6heh">
          Stop jumping between scattered references and guessing which component may have failed.
        </p>
        <p className="mt-1 font-heading text-[0.74rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.88rem]" data-id="element-55" data-mp="2c56hmm3ph1ru">
          Identify the symptom. Check the system. Test the component. Isolate the fault.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[240px] sm:max-w-[300px]" data-id="element-56" data-mp="2m21e6zgf4s3h" />

        <p className="mt-2 font-heading text-[1rem] font-black uppercase text-white sm:text-[1.4rem]" data-id="element-57" data-mp="2r276mhuiiimm">
          🔧 KITCHEN EQUIPMENT DIAGNOSTIC <span className="text-gold" data-id="element-58" data-mp="2v38ww96gbkcg">PRO™</span>
        </p>
        <p className="mt-0.5 text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.8rem]" data-id="element-59" data-mp="301tzgf96eg42">
          THE COMPLETE FAULT-FINDING SYSTEM FOR COMMERCIAL KITCHEN EQUIPMENT TECHNICIANS
        </p>
        <p className="mt-0.5 text-[0.62rem] font-bold uppercase tracking-[0.12em] text-gold sm:text-[0.76rem]" data-id="element-60" data-mp="39rdjho8mkg0i">
          Identify • Check • Test • Compare • Isolate • Diagnose
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-61" data-mp="3isbr0gi9v5nu">
          <p className="font-heading text-[0.78rem] font-black uppercase tracking-wide text-white sm:text-[0.92rem]" data-id="element-62" data-mp="3ir0nmhsqnzx9">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-63" data-mp="1eqtmhlsh318a">
            <CTAButton label="⚡ GET KITCHEN EQUIPMENT DIAGNOSTIC PRO™" data-id="element-64" data-mp="1sgn8zxgi99eu" />
          </div>
          <p className="mt-2 text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-65" data-mp="1sihvvhbc7blk">
            Immediate Access • Digital Delivery
          </p>
          <p className="mt-0.5 text-[0.64rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-66" data-mp="22djnqkwzyrru">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}